import { baseApi } from 'app/baseApi';
import { apiTags } from 'app/store/apiTags';
import { workRequestActions } from './workRequestConsts';

const apiPrefix = 'workrequest';

const invalidatedTags = [apiTags.MECHANICAL_TASK, apiTags.ACTIVITY_LOG, apiTags.ACTIVITY_FEED_LOG];

const idMutation = (builder, action) => builder.mutation({
    query: ({ workRequestId }) => ({
        url: `${apiPrefix}/${action}`,
        method: 'POST',
        body: { workRequestId }
    }),
    invalidatesTags: invalidatedTags
});

const reasonMutation = (builder, action) => builder.mutation({
    query: ({ workRequestId, reason }) => ({
        url: `${apiPrefix}/${action}`,
        method: 'POST',
        body: { workRequestId, reason }
    }),
    invalidatesTags: invalidatedTags
});

export const workRequestApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        sendTechnician: builder.mutation({
            query: ({ workRequestId, arrivalTime, arrivalType }) => ({
                url: `${apiPrefix}/${workRequestActions.SEND_TECHNICIAN}`,
                method: 'POST',
                body: { workRequestId, arrivalTime, arrivalType }
            }),
            invalidatesTags: invalidatedTags
        }),
        rejectWorkRequest: builder.mutation({
            query: ({ workRequestId, rejectionReason }) => ({
                url: `${apiPrefix}/${workRequestActions.REJECT}`,
                method: 'POST',
                body: { workRequestId, rejectionReason }
            }),
            invalidatesTags: invalidatedTags
        }),
        sendEstimate: builder.mutation({
            query: ({ workRequestId, labor, parts, discounts, taxes, other }) => ({
                url: `${apiPrefix}/${workRequestActions.ESTIMATE}`,
                method: 'POST',
                body: { workRequestId, labor, parts, discounts, taxes, other }
            }),
            invalidatesTags: invalidatedTags
        }),
        completeWorkRequest: idMutation(builder, workRequestActions.COMPLETE),
        simulateDryRun: idMutation(builder, workRequestActions.DRY_RUN),
        delayWorkOrder: reasonMutation(builder, workRequestActions.DELAY),
        cancelWorkRequest: reasonMutation(builder, workRequestActions.CANCEL),
        acceptCancellation: idMutation(builder, workRequestActions.ACCEPT_CANCELLATION),
        rejectCancellation: idMutation(builder, workRequestActions.REJECT_CANCELLATION),
    })
});

export const {
    useSendTechnicianMutation,
    useRejectWorkRequestMutation,
    useCompleteWorkRequestMutation,
    useSimulateDryRunMutation,
    useDelayWorkOrderMutation,
    useCancelWorkRequestMutation,
    useAcceptCancellationMutation,
    useRejectCancellationMutation,
    useSendEstimateMutation,
} = workRequestApi;
